import { useState, useEffect } from 'react';
import { getHuntItems, voteHuntItem } from '../services/firestore';

export function useHuntItems() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [error, setError] = useState(null);
  const [lastDoc, setLastDoc] = useState(null);
  const [hasMore, setHasMore] = useState(true);

  const fetchItems = async (reset = false) => {
    try {
      if (reset) {
        setLoading(true);
        setLastDoc(null);
      }
      // Fetch 50 items initially to get more items per time period
      const { items: data, lastDoc: newLastDoc, hasMore: more } = await getHuntItems(50, reset ? null : null);
      setItems(data);
      setLastDoc(newLastDoc);
      setHasMore(more);
      setError(null);
    } catch (err) {
      console.error('Error fetching hunt items:', err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const loadMore = async () => {
    if (!hasMore || loadingMore) return;

    try {
      setLoadingMore(true);
      // Load more in batches of 30
      const { items: data, lastDoc: newLastDoc, hasMore: more } = await getHuntItems(30, lastDoc);
      setItems(prev => [...prev, ...data]);
      setLastDoc(newLastDoc);
      setHasMore(more);
    } catch (err) {
      console.error('Error loading more items:', err);
    } finally {
      setLoadingMore(false);
    }
  };

  useEffect(() => {
    fetchItems(true);
  }, []);

  const vote = async (itemId, userId, voteType) => {
    try {
      await voteHuntItem(itemId, userId, voteType);
      await fetchItems(true); // Refresh the list
    } catch (err) {
      console.error('Error voting:', err);
      throw err;
    }
  };

  return { items, loading, loadingMore, error, refetch: () => fetchItems(true), vote, loadMore, hasMore };
}
